import Vue from "vue";
import Router from "vue-router";
import Routes from "@/modules/form.js";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: Routes,
  scrollBehavior(to, from) {
    // console.log("TCL: scrollBehavior -> to, from", to, from);
    if (to.name !== from.name) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 0);
      });
    }
  }
});

router.beforeEach((to, from, next) => {
  // console.log("TCL: to, from", to, from);
  if (
    to.path === "/" &&
    to.query.edit === undefined
    ) {
    next({ path: '/booking/departing' });
  } else {
    next();
  }
});

Vue.use(router);

export default router;
